<template>
	<div>
		<ol class="breadcrumb">
			<li class="breadcrumb-item" v-for="(item, index) in items" :key="index">
				<router-link :to="item.url" v-if="!item.last">{{ item.name }}</router-link>
				<span class="active" v-else>{{ item.name }}</span>
			</li>
		</ol>
		<slot />
	</div>
</template>
<script>
import axios from 'axios'

export default {
	data() {
		return {
			trans_segments: {
				[this.$t('chatbots')]: 'chatbots',
				[this.$t('services')]: 'services',
				[this.$t('commands')]: 'commands',
				[this.$t('variables')]: 'variables',
                [this.$t('menus')]: 'menus',
				[this.$t('dataset')]: 'dataset',
				[this.$t('subscription')]: 'subscription',
				[this.$t('datasources')]: 'datasources',
			},
			items: [
				{
					name: 'Home',
					url: '/',
					last: false,
				},
			],
            clousers: [],
		}
	},
	methods: {
		init() {
			let tempUrl = '/'
			let url = location.hash.replace('#', '').split('/')

			url.splice(0, 1)
			while (url.length) {
				let item = '' + url.splice(0, 1)
				item = item.replace(/\?page=(\d+)/, '')
				if (is_str(item) && !(parseInt(item) + 1)) {
					this.items.push({
						name: this.$t(item),
						url: tempUrl + item,
						last: !url.length,
					})
				} else {
					let apiUrl
					let lastTemp = this.items[this.items.length - 1].name.slice()
					this.items.push({
						name: parseInt(item) === 0 ? 'New ' + lastTemp : '..',
						url: tempUrl + item,
						last: !url.length,
					})
					let posation = this.items.length - 1
					lastTemp = this.trans_segments[lastTemp]
					// console.log(lastTemp)
					if (parseInt(item) > 0) {
						switch (lastTemp) {
							case 'chatbots':
								apiUrl = '/chatbot/browse/' + item
								break
                            case 'menus':
							case 'dataset':
								apiUrl = '/dataset/browse/' + item
								break
							case 'services':
								apiUrl = '/service/browse/' + item
								break
							case 'commands':
								apiUrl = '/command/browse/' + item
								break
							case 'variables':
								apiUrl = '/command_var/browse/' + item
								break
							case 'subscription':
								apiUrl = '/subscription/browse/' + item
								break
							case 'datasources':
								apiUrl = '/data_sources/browse/' + item
								break
						}
						if (apiUrl) {
							if (
								!this.$store.state.breadcrumb_history[lastTemp] ||
								!this.$store.state.breadcrumb_history[lastTemp][item]
							) {
								axios.get(apiUrl).then(({data}) => {
									if (data.status && this.items[posation]) {
										switch (lastTemp) {
											case 'chatbots':
												this.items[posation].name = data.data.chatbot_name
												break
                                            case 'menus':
											case 'dataset':
												this.items[posation].name = data.data.ds_name
												break
											case 'services':
												this.items[posation].name = data.data.service_name
												break
											case 'commands':
												this.items[posation].name = data.data.command_name
												break
											case 'variables':
												this.items[posation].name = data.data.var_name
												break
											case 'subscription':
												this.items[posation].name = data.data.sc_title
												break
											case 'datasources':
												this.items[posation].name = data.data.entity.name
												break
										}
										this.$store.commit('add_breadcrumb_history', {
											[lastTemp]: {
												[item]: {
													meta: this.items[posation],
													data: data.data,
												},
											},
										})
									}
								})
							} else {
								this.items[posation].name = this.$store.state.breadcrumb_history[lastTemp][item][
									'meta'
								]['name']
							}
						}
					}
				}
				tempUrl += (item + '/')
			}
		},
	},
	mounted() {
		this.init()
	},
}
</script>
